// Copyright © 2026 Qcells. All rights reserved.
//
// This software is proprietary and confidential. Unauthorized use,
// duplication, or distribution of software is strictly prohibited.

import type { Artifact, PolicyDetail } from '../types/procedures';

/**
 * Inverse of `toPolicyDetail()` — maps the guided-form's editable shape
 * back onto the real `Artifact` envelope for saving, always stamping
 * `language: 'rego'` since that's the only language `PolicyPayload` allows.
 */
export function fromPolicyDetail(policy: PolicyDetail, original: Artifact): Artifact {
  return {
    ...original,
    // `toPolicyDetail` reads `policyNumber` from this same field. On a
    // brand-new draft `artifactId` is blank and `policyNumber` is the one
    // the user actually types into the guided form — write that back, or a
    // create/save silently goes out with an empty artifact id.
    artifact_id: policy.policyNumber || policy.artifactId,
    artifact_type: policy.artifactType,
    title: policy.title,
    version: policy.version,
    status: policy.status,
    categories: {
      ...original.categories,
      domain: policy.classification,
      policy_domain: policy.policyDomain,
      scope: policy.scope,
      enforcement_point: policy.enforcementPoint,
    },
    payload: {
      ...original.payload,
      package: policy.package,
      language: 'rego',
      decision_summary: policy.decisionSummary,
      files: {
        policy: policy.files.policy,
        data: policy.files.data,
        tests: policy.files.tests,
      },
    },
  };
}
